/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Stack, Typography } from "@mui/material";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird.tsx";
import { EventNote } from "@mui/icons-material";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";

export default function LinkStyleguide(){
  return (
    <>
      <StyleguideView title={"Text"}>
        <Typography>
          Lorem ipsum dolor sit amet, <LinkLegalbird to={"/"}>consetetur sadipscing elitr</LinkLegalbird>, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
          sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,{" "}
          <LinkLegalbird to={"/"}>
            consetetur sadipscing elitr <EventNote />
          </LinkLegalbird>
          , sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
        </Typography>
      </StyleguideView>
      <StyleguideView title={"Standalone Medium"}>
        <Stack spacing={"1.5rem"}>
          <Box>
            <LinkLegalbird to={"#"} standalone variant={"medium"}>
              Lorem ipsum dolor.
            </LinkLegalbird>
          </Box>
          <Box>
            <LinkLegalbird to={"#"} standalone variant={"medium"}>
              Lorem ipsum dolor <EventNote />
            </LinkLegalbird>
          </Box>
        </Stack>
      </StyleguideView>
      <StyleguideView title={"Standalone Small"}>
        <Stack direction={"column"} spacing={"1.5rem"}>
          <Box>
            <LinkLegalbird to={"#"} standalone variant={"small"}>
              Lorem ipsum dolor.
            </LinkLegalbird>
          </Box>
          <Box>
            <LinkLegalbird to={"#"} standalone variant={"small"}>
              Lorem ipsum dolor <EventNote />
            </LinkLegalbird>
          </Box>
        </Stack>
      </StyleguideView>
    </>
  );
};
